<template>
    <section id="cta-content">

        <div class="container content_title">
            <!-- <span>MPH=methylphenidate; PD=pharmacodynamic; PK=pharmacokinetic; SKAMP=Swanson, Kotkin, Agler, M-Flynn, and Pelham.</span> -->
        </div>

        <CTABanner 
            :onlyBanner="true" :bannerData="{bannerText: 'See PK PROFILE', href:'/pk-data'}"/>

    </section>
</template>

<script>

import CTABanner from "../CTABanner.vue";

export default {
    components: {
        CTABanner
    },
    data() {
        return {
        }
    }


}
</script>